import time from 'utils/time';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import InteractionCard, { InteractionListSkeleton } from 'components/Dashboard/Influence/CrmInteractions/InteractionCard';
import useCallInteractionsForCell from '../useCallInteractionsForCell';

const formatCellHeading = ({ cell, currentView }) => {
  const bucketLabel = cell.label ?? 'All engagement';
  const dateLabel =
    currentView === 'Month'
      ? time(cell.date).format('MMMM YYYY')
      : currentView === 'Week'
        ? `week of ${time(cell.date).format('DD MMM YYYY')}`
        : time(cell.date).format('DD MMM YYYY');
  return `${bucketLabel} - ${dateLabel}`;
};

const EngagementStatsRightPanel = ({ cell, breakdownBy, currentView, onClose }) => {
  const { interactions, isLoading } = useCallInteractionsForCell({ cell, breakdownBy, currentView });

  return (
    <div className='analytics-content-items-panel'>
      <div className='h-100 border bg-white position-relative analytics-content-items-container'>
        <CustomScrollbar className='simple-scrollbar top-content-scrollbar smooth-scrolling'>
          <h3 className='analytics-panel-title title-h5-m-bold pt-3 bg-white mb-0 pb-2 px-3'>
            {formatCellHeading({ cell, currentView })}
          </h3>
          <button
            className='general-button circle-button border bg-main-blue text-white z-max analytics-close-button'
            style={{ right: '13px', top: '11px' }}
            onClick={onClose}
            data-tooltip-content='Close side panel'
            data-tooltip-id='general-tooltip'
          >
            <span className='icon-close paragraph-p6 d-inline-block' style={{ verticalAlign: 'middle', marginTop: '-2px' }} />
          </button>
          <div className='py-3 px-3'>
            {isLoading ? (
              <InteractionListSkeleton />
            ) : (
              <>
                <ul className='policy-list px-0 items-list'>
                  {(interactions ?? []).map((item) => (
                    <InteractionCard key={item.id} item={item} compact />
                  ))}
                </ul>
                {interactions?.length === 0 && (
                  <p className='text-center main-light-text' style={{ marginTop: '150px' }}>
                    No interactions
                  </p>
                )}
              </>
            )}
          </div>
        </CustomScrollbar>
      </div>
    </div>
  );
};

export default EngagementStatsRightPanel;
